export default __webpack_public_path__ + "static/media/atar-calc.c033fdfd.png";